let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e8CAg")).then(() => parcelRequire('i7S3K'));